import React, { useState, useEffect } from 'react'
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux'
import GlobalPolicies from '../../components/GlobalPolicies/GlobalPolicies'
import EditUserModal from './EditUserModal'
import ChangePasswordModal from './ChangePasswordModal'
import CheckEmailModal from './CheckEmailModal'
import Toast from '../../components/Toast/Toast'
import API from '../../utils/API'
import constants from '../../utils/constants'
import { setUserState } from '../../store/user';
import './Settings.css'

function Settings(props) {
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');
  const [sentEmail, setSentEmail] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);

  // Global Policy states
  const [passwordLength, setPasswordLength] = useState('');
  const [passwordPolicy, setPasswordPolicy] = useState(false);
  const [twoFactorAuth, setTwoFactorAuth] = useState(false);
  const [firstLogin, setFirstLogin] = useState(false);
  const [status, setStatus] = useState('');

  // Global Policy IDs
  const policyID = constants.globalPolicies;

  const { user } = props;

  const userModalProps = {
    email, setEmail, phone, setPhone, error, handleDone, firstName, setFirstName,
    lastName, setLastName,
  }

  const checkEmailModalProps = {
    sentEmail, error, closeModal
  }

  const passwordModalProps = {
    oldPassword, setOldPassword, newPassword, setNewPassword, closeModal, handlePasswordSubmit, error,
    clearPasswordModal
  }

  useEffect(() => {
    if(user) {
      setEmail(user.email);
      setFirstName(user.firstName);
      setLastName(user.lastName);
      setPhone(user.phone);
    }

    API.getGlobalPolicies()
      .then((res)=>{
        let minLengthPerm = res.data.find(policy => policy.global_policy_id === constants.globalPolicies.password)
        let changePassPerm = res.data.find(policy => policy.global_policy_id === constants.globalPolicies.changePasswordOnFirstLogin)
        console.log(res.data);
        if(minLengthPerm && minLengthPerm.settings) {
          setPasswordPolicy(true);
          setPasswordLength(minLengthPerm.settings.minimumLength)
        }
        if(changePassPerm) {
          setFirstLogin(true);
        }
      })
      .catch((err)=>{
        console.error(err);
      })
  }, []);

  /**
   * Opens check email modal
   */
  function openModal() {
    document.getElementById("backdrop").style.display = "block"
    document.getElementById("checkEmailModal").style.display = "block"
    document.getElementById("checkEmailModal").classList.add("show")
  }

  /**
   * Closes modal.
   */
  function closeModal() {
    document.getElementById('btn-close').click();
    document.getElementById('password-btn-close').click();
    document.getElementById("backdrop").style.display = "none"
    document.getElementById("checkEmailModal").style.display = "none"
    document.getElementById("checkEmailModal").classList.remove("show")
  }

  /**
   * Handle save button click to update global policies
   * @param {Event} e 
   */
  function handleSaveClick(e) {
    e.preventDefault();
    // Minimum length limited to double digit
    let passwordObj = {minimumLength: parseInt(passwordLength, 10)}

    // Update setting if active, delete if inactive
    if(passwordPolicy) {
      if(!passwordLength) {
        setStatus('MISSING_PASSWORD_MINI_LENGTH');
        return;
      }
      API.updateGlobalPolicy(policyID.password, passwordObj)
        .then(res => {
          setStatus('SUCCESS');
        }).catch(err => {
          // TODO: Handle empty password length field and set error message
          console.error(err);
          setStatus(err.message)
        })
    } else {
      API.deleteGlobalPolicy(policyID.password);
      setStatus('SUCCESS');
    }

    if(firstLogin){
      API.updateGlobalPolicy(policyID.changePasswordOnFirstLogin)
        .then(res => {
          setStatus('SUCCESS');
        }).catch(err => {
          console.error(err);
          setStatus(err.message)
        })
    } else {
      API.deleteGlobalPolicy(policyID.changePasswordOnFirstLogin)
        .then(res => {
          setStatus('SUCCESS');   
        }).catch(err => {
          console.error(err);
          setStatus(err.message)
        })
    }

    if(twoFactorAuth) {
      API.updateGlobalPolicy(policyID.twoFactorAuth)
        .then(res => {
          setStatus('SUCCESS');
        }).catch(err => {
          console.error(err);
          setStatus(err.message)
        })
    } else {
      API.deleteGlobalPolicy(policyID.twoFactorAuth)
        .then(res => {
          setStatus('SUCCESS');
        }).catch(err => {
          console.error(err);
          setStatus(err.message)
        })
    }
  }

  function handleChangePasswordLength(e) {
    e.preventDefault();
    setPasswordLength(e.target.value);
  }

  function handlePasswordLengthClick(e) {
    e.preventDefault();
    e.target.focus();
    e.target.select();
    return;
  }
  /**
   * Handle toggle of password switch
   */
  function togglePassword() {
    setPasswordPolicy(prevState => !prevState);
    setPasswordLength('');
  }

  /**
   * Handle toggle of 2FA switch
   */
  function toggle2FA() {
    setTwoFactorAuth(prevState => !prevState);
  }

  /**
   * Toggle firstLogin
   */
  function toggleFirstLogin() {
    setFirstLogin(prevState => !prevState);
  }

  function clearPasswordModal(e) {
    setError("");
    setOldPassword("");
    setNewPassword("");
  }

  // Take info and update account owner info
  function handleDone() {
    API.editUser({
      email: email,
      phone: phone,
      firstName: firstName,
      lastName: lastName,
      id: user.id
    }).then(res => {
      const { data } = res
      console.log('a', res);
      props.dispatch(setUserState({ email, phone, firstName, lastName, }))
      if (data.error) return setError(data.error)
      closeModal();
      API.logout()
        .then(res => {
          const { data } = res
          if (data.error) return setError(data.error)
          props.dispatch(setUserState(''))
          window.location = '/login'
        }).catch(err => {
          console.error(err)
        });
    }).catch(err => {
      console.error(err)
      setError(err.message)
    })
  }

  function handlePasswordSubmit() {
    API.changePassword(oldPassword, newPassword)
    .then((res)=>{
      clearPasswordModal();
      closeModal();
      window.location = '/login';
    })
    .catch((err)=>{
      console.error(err);
      if(err.response.status === 401){
        err.message = <FormattedMessage id="CURRENT_PASSWORD_INCORRECT" />;
      }
      setError(err.message);
    })
  }

  function emailPasswordReset() {
    API.emailResetPassword({ email })
      .then(res => {
        const { data } = res
        if (data.error) return setError(data.error)
        setSentEmail(true);
        openModal();
      }).catch(err => {
        console.error(err)
        setSentEmail(false);
        setError(err.message);
        openModal();
      })
  }

  function toggleDarkMode() {
    setIsDarkMode(!isDarkMode);
  }

  return (
    <div>
      <h3 className="title">Settings</h3>
      <hr className="mt-0 mb-4" />
      <h4 className="px-2 mb-3">Global Policies</h4>
      <div className="settingsContainer">
        <div className="list-group">
          <form className="px-3 py-1">
            {/* <div className="mb-3 row">
              <div className="form-check">
                <input
                  className="form-check-input" 
                  type="checkbox" 
                  value="" 
                  id="passwordCheck" 
                  checked={passwordPolicy} 
                  onChange={(e) => togglePassword(e)}  
                />
                <label className="form-check-label" htmlFor="passwordCheck">
                  Password Length
                </label>
              </div>
              <div className={"collapse row mt-2 " + (passwordPolicy ? "show" : "")} id="passwordCollapse">
                <label htmlFor="passwordLength" className="col-sm-auto ms-3 mt-1">Minimum length:</label>
                <div id="minLengthBox">
                  <input 
                    className="form-control" 
                    id="dropdownPasswordLength" 
                    type="text"
                    pattern="^[0-9]{1,2}$"
                    maxLength="2"
                    value={passwordLength} 
                    onClick={(e)=> handlePasswordLengthClick(e)} 
                    onChange={(e) => handleChangePasswordLength(e)} 
                  />
                </div>
              </div>
            </div> */}
            <div className="mb-3 row">
              <div className="form-check">
                <input onChange={(e)=>toggleFirstLogin(e)} className="form-check-input" type="checkbox" value="" id="firstLogin" checked={firstLogin}/>
                <label className="form-check-label" htmlFor="firstLogin">
                  <FormattedMessage id="REQ_PASSWORD_CHANGE" defaultMessage="Require password change on first login" />
                </label>
              </div>
            </div>
            {/* <div className="mb-3 row">
              <div className="form-check">
                <input onChange={(e) => toggle2FA(e)} className="form-check-input" type="checkbox" value="" id="twoFactorCheck" checked={twoFactorAuth}/>
                <label className="form-check-label" htmlFor="twoFactorCheck">
                  Two-Factor Authentication (Not Implemented Yet)
                </label>
              </div>
            </div> */}
            <div className="row justify-content-center">
              <button onClick={(e) => handleSaveClick(e)} type="submit" className="btn save-btn">
                <FormattedMessage id="SAVE" defaultMessage="Save"/>
              </button>
              {status && 
                <p className={`status mt-2 mb-0 ${status === 'SUCCESS' ? 'text-success' : 'text-danger'}`}>
                  {status !== "" ? <FormattedMessage id={status} /> : ""}
                </p>}
            </div>
          </form>
        </div>
      </div>
      <CheckEmailModal {...checkEmailModalProps} />
    </div>
  )
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(Settings)